import { useAtom } from "jotai";
import React from "react";
import { actionUIAtom } from "../../../../db";
import QDrawer from "./QDrawer";
import log from "cslog";
import QModal from "./QModal";

function ActionUI(props) {
    // const [action, setAction] = useRecoilState(actionUIState);
    const [action, setAction] = useAtom(actionUIAtom);

    log.d(action, "action in ActionUI");

    switch (action.type) {
        case "drawer":
            return <QDrawer {...props} action={action} setAction={setAction} />;
        case "popup":
            return <QModal {...props} action={action} setAction={setAction} />;
        case "flip_to_page":
            if (props?.flipTo) {
                props.flipTo(action.params);
                setAction({
                    type: "none",
                    params: {},
                });
            }
            return <></>;
        default:
            return <></>;
    }
}

export default ActionUI;
